document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-al-sort]').forEach(select => select.addEventListener('change', () => select.form.requestSubmit()));
  document.querySelectorAll('.accordion__tab').forEach(button => {
    const panel = button.closest('.accordion-wrapper')?.querySelector('.accordion__panel');
    if(!panel) return;
    const toggle = expanded => {
      button.setAttribute('aria-expanded', String(expanded));
      panel.hidden = !expanded;
      panel.style.display = expanded ? 'block' : 'none';
      button.closest('.accordion-wrapper').classList.toggle('active', expanded);
    };
    toggle(false);
    button.addEventListener('click', () => toggle(button.getAttribute('aria-expanded') !== 'true'));
  });
  const cartDrawer = (() => {
    const dialog = document.querySelector('[data-al-cart-drawer]');
    if(!dialog?.showModal) return null;
    const sectionId = dialog.dataset.sectionId;
    const cartLink = document.getElementById('cart-icon-bubble');
    const loading = dialog.querySelector('[data-al-drawer-loading]');
    const error = dialog.querySelector('[data-al-drawer-error]');
    const status = dialog.querySelector('[data-al-drawer-status]');
    let opener;
    let busy = false;
    let requests = Promise.resolve();
    const content = () => dialog.querySelector('[data-al-drawer-content]');
    const setError = message => {
      error.textContent = message || '';
      error.hidden = !message;
    };
    const updateCount = () => {
      const count = Number(content().dataset.cartCount);
      dialog.querySelector('[data-al-drawer-count]').textContent = `(${count})`;
      if(!cartLink) return;
      cartLink.setAttribute('aria-label', content().dataset.cartLabel);
      let bubble = cartLink.querySelector('.cart-count-bubble');
      if(!bubble) {
        bubble = document.createElement('span');
        bubble.className = 'cart-count-bubble';
        bubble.setAttribute('aria-hidden', 'true');
        cartLink.append(bubble);
      }
      bubble.textContent = String(count);
      bubble.hidden = count === 0;
    };
    const setBusy = active => {
      busy = active;
      loading.hidden = !active;
      content().setAttribute('aria-busy', String(active));
      dialog.querySelectorAll('[data-al-cart-control]').forEach(control => {
        if(active) {
          control.dataset.alWasDisabled = String(control.disabled);
          control.disabled = true;
        } else if(control.dataset.alWasDisabled !== undefined) {
          control.disabled = control.dataset.alWasDisabled === 'true';
          delete control.dataset.alWasDisabled;
        }
      });
    };
    const enqueue = operation => {
      const request = requests.then(async () => {
        setBusy(true);
        setError('');
        status.textContent = dialog.dataset.loadingText;
        try { return await operation(); }
        catch(failure) {
          if(failure instanceof TypeError || failure instanceof SyntaxError) throw new Error(dialog.dataset.errorText);
          throw failure;
        }
        finally { setBusy(false); }
      });
      requests = request.catch(() => {});
      return request;
    };
    const show = trigger => {
      if(dialog.open) return;
      opener = trigger || document.activeElement;
      dialog.showModal();
      document.body.classList.add('al-cart-drawer-open');
      cartLink?.setAttribute('aria-expanded', 'true');
    };
    const close = () => dialog.close();
    dialog.addEventListener('close', () => {
      document.body.classList.remove('al-cart-drawer-open');
      cartLink?.setAttribute('aria-expanded', 'false');
      const previous = opener;
      if(previous?.isConnected && !previous.disabled) previous.focus();
      else requests.then(() => { if(!dialog.open && previous?.isConnected) previous.focus(); });
    });
    dialog.addEventListener('cancel', event => { event.preventDefault(); close(); });
    const sections = () => {
      const ids = [sectionId];
      const cartPageSection = document.querySelector('.al-cart-page')?.closest('[id^="shopify-section-"]');
      if(cartPageSection) ids.push(cartPageSection.id.replace('shopify-section-', ''));
      return ids;
    };
    const renderSections = htmlById => {
      const html = htmlById?.[sectionId];
      if(!html) return false;
      const parsed = new DOMParser().parseFromString(html, 'text/html');
      const nextContent = parsed.querySelector('[data-al-drawer-content]');
      if(!nextContent) return false;
      content().replaceWith(nextContent);
      const cartPage = document.querySelector('.al-cart-page');
      const pageSectionId = cartPage?.closest('[id^="shopify-section-"]')?.id.replace('shopify-section-', '');
      if(pageSectionId && htmlById[pageSectionId]) {
        const pageHtml = new DOMParser().parseFromString(htmlById[pageSectionId], 'text/html');
        const nextPage = pageHtml.querySelector('.al-cart-page');
        if(nextPage) cartPage.replaceWith(nextPage);
      }
      updateCount();
      return true;
    };
    const fetchSections = async () => {
      const root = window.Shopify?.routes?.root || window.routes.cart_url.replace(/cart\/?$/, '');
      const url = new URL(root, window.location.origin);
      const currentUrl = new URL(window.location.href);
      ['preview_theme_id', 'preview_token'].forEach(name => {
        if(currentUrl.searchParams.has(name)) url.searchParams.set(name, currentUrl.searchParams.get(name));
      });
      url.searchParams.set('section_id', sectionId);
      const response = await fetch(url, {headers:{Accept:'text/html'}, credentials:'same-origin', cache:'no-store'});
      if(!response.ok || !renderSections({[sectionId]:await response.text()})) throw new Error(dialog.dataset.errorText);
    };
    const refresh = () => enqueue(async () => {
      await fetchSections();
      status.textContent = dialog.dataset.updatedText;
    });
    const renderCart = async result => {
      if(!renderSections(result.sections)) await fetchSections();
    };
    const errorMessage = result => typeof result.description === 'string' ? result.description : (typeof result.message === 'string' ? result.message : dialog.dataset.errorText);
    const changeQuantity = (input, quantity, focusDirection) => {
      if(busy) return;
      const line = input.closest('[data-al-drawer-line]');
      const index = line.dataset.lineIndex;
      if(!Number.isInteger(quantity) || quantity < 0 || (quantity !== 0 && !input.checkValidity())) {
        input.value = input.dataset.currentQuantity;
        setError(dialog.dataset.quantityErrorText);
        input.focus();
        return;
      }
      if(quantity === Number(input.dataset.currentQuantity)) return;
      enqueue(async () => {
        const response = await fetch(window.routes.cart_change_url + '.js', {
          method:'POST', credentials:'same-origin', headers:{'Content-Type':'application/json', Accept:'application/json'},
          body:JSON.stringify({id:line.dataset.lineKey, quantity, sections:sections(), sections_url:window.location.pathname + window.location.search})
        });
        const result = await response.json();
        if(!response.ok) throw new Error(errorMessage(result));
        await renderCart(result);
        status.textContent = dialog.dataset.updatedText;
        if(dialog.open) {
          const nextLine = [...dialog.querySelectorAll('[data-al-drawer-line]')].find(element => element.dataset.lineIndex === index);
          const nextFocus = focusDirection ? nextLine?.querySelector(`[data-al-cart-step="${focusDirection}"]`) : nextLine?.querySelector('[data-al-drawer-quantity]');
          const availableFocus = nextFocus?.disabled ? nextLine?.querySelector('[data-al-drawer-quantity]') : nextFocus;
          (availableFocus || dialog.querySelector('.al-drawer-empty a') || dialog.querySelector('[data-al-drawer-close]')).focus();
        }
      }).catch(failure => {
        if(input.isConnected) input.value = input.dataset.currentQuantity;
        setError(failure.message || dialog.dataset.errorText);
      });
    };
    dialog.addEventListener('click', event => {
      if(event.target.closest('[data-al-drawer-close]')) { close(); return; }
      if(event.target === dialog) {
        const bounds = dialog.getBoundingClientRect();
        if(event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) close();
        return;
      }
      const step = event.target.closest('[data-al-cart-step]');
      const remove = event.target.closest('[data-al-drawer-remove]');
      if(!step && !remove) return;
      if(busy) return;
      const input = (step || remove).closest('[data-al-drawer-line]').querySelector('[data-al-drawer-quantity]');
      let quantity = 0;
      if(step) {
        const minimum = Number(input.min) || 1;
        const increment = Number(input.step) || 1;
        const current = Number(input.dataset.currentQuantity);
        quantity = step.dataset.alCartStep === 'plus' ? current + increment : current - increment;
        if(quantity < minimum) quantity = 0;
        input.value = String(quantity);
      }
      changeQuantity(input, quantity, step?.dataset.alCartStep);
    });
    dialog.addEventListener('change', event => {
      const input = event.target.closest('[data-al-drawer-quantity]');
      if(input) changeQuantity(input, input.value.trim() ? Number(input.value) : NaN);
    });
    dialog.addEventListener('keydown', event => {
      const input = event.target.closest('[data-al-drawer-quantity]');
      if(input && event.key === 'Enter') {
        event.preventDefault();
        changeQuantity(input, input.value.trim() ? Number(input.value) : NaN);
      }
    });
    if(cartLink) {
      cartLink.href = window.routes.cart_url;
      cartLink.setAttribute('aria-haspopup', 'dialog');
      cartLink.setAttribute('aria-controls', dialog.id);
      cartLink.setAttribute('aria-expanded', 'false');
      cartLink.addEventListener('click', event => {
        if(event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        show(cartLink);
        if(!busy) refresh().catch(failure => setError(failure.message || dialog.dataset.errorText));
      });
    }
    updateCount();
    return {
      add: (form, trigger) => enqueue(async () => {
        const data = new FormData(form);
        data.set('sections', sections().join(','));
        data.set('sections_url', window.location.pathname + window.location.search);
        const response = await fetch(window.routes.cart_add_url + '.js', {method:'POST', credentials:'same-origin', body:data, headers:{Accept:'application/json'}});
        const result = await response.json();
        if(!response.ok) throw new Error(errorMessage(result));
        show(trigger);
        try {
          await renderCart(result);
          status.textContent = dialog.dataset.addedText;
        } catch(failure) {
          setError(failure.message || dialog.dataset.errorText);
        }
      })
    };
  })();
  const bindAddForm = (form, main, afterSubmit) => {
    if(!cartDrawer) return;
    form.addEventListener('submit', async event => {
      event.preventDefault();
      const button = event.submitter || form.querySelector('button[type="submit"]');
      if(button?.disabled || form.getAttribute('aria-busy') === 'true' || !form.querySelector('[name="id"]')?.value) return;
      const error = form.querySelector('.al-product-error') || main.querySelector('.al-product-error') || document.createElement('p');
      error.className = 'al-product-error';
      error.setAttribute('role','alert');
      error.textContent = '';
      form.setAttribute('aria-busy', 'true');
      if(button) button.disabled = true;
      try { await cartDrawer.add(form, button); }
      catch(failure) {
        error.textContent = failure.message;
        if(!error.isConnected) form.append(error);
      } finally {
        form.removeAttribute('aria-busy');
        if(button) button.disabled = false;
        afterSubmit?.();
      }
    });
  };
  const money = value => new Intl.NumberFormat('en-US', {style:'currency', currency:'USD'}).format(value / 100) + ' USD';
  document.querySelectorAll('[data-al-product]').forEach(element => {
    const product = JSON.parse(element.textContent);
    const main = element.closest('#MainContent') || document;
    const picker = main.querySelector('[data-al-picker]');
    const forms = [...main.querySelectorAll('[data-al-product-form]')];
    const select = () => {
      const options = picker ? [...picker.querySelectorAll('fieldset')].map(field => field.querySelector('input:checked')?.value).filter(Boolean) : [];
      const variant = product.variants.find(v => options.every((option, index) => option === v.options[index])) || product.variants[0];
      forms.forEach(form => {
        const input = form.querySelector('[name="id"]');
        if(input) input.value = variant.id;
        form.querySelectorAll('button[type="submit"]').forEach(button => {
          button.disabled = !variant.available || form.getAttribute('aria-busy') === 'true';
          const span = button.querySelector('span');
          if(span) span.textContent = variant.available ? window.variantStrings.addToCart : window.variantStrings.soldOut;
        });
      });
      const price = main.querySelector('product-info .price');
      if(price) {
        const discounted = variant.compare_at_price > variant.price;
        price.classList.toggle('price--on-sale', discounted);
        price.querySelectorAll('.price__regular .price-item--regular').forEach(el => el.textContent = money(variant.price));
        price.querySelectorAll('.price-item--sale').forEach(el => el.textContent = money(variant.price));
        price.querySelectorAll('.price__sale .price-item--regular').forEach(el => el.textContent = variant.compare_at_price ? money(variant.compare_at_price) : '');
      }
      if(variant.featured_image) {
        const image = main.querySelector('.product__media img');
        if(image) { image.src = variant.featured_image.src; image.removeAttribute('srcset'); }
      }
    };
    picker?.addEventListener('change', select);
    select();
    forms.forEach(form => bindAddForm(form, main, select));
  });
  document.querySelectorAll('form:not([data-al-product-form])').forEach(form => {
    if(new URL(form.action, window.location.href).pathname === window.routes.cart_add_url) bindAddForm(form, form.closest('#MainContent') || document);
  });
  document.querySelectorAll('media-gallery').forEach(gallery => {
    gallery.querySelectorAll('[data-target]').forEach(button => button.addEventListener('click', () => {
      const media = document.getElementById(button.dataset.target);
      media?.scrollIntoView({behavior:'smooth',block:'nearest',inline:'center'});
    }));
  });
});
if(!customElements.get('sticky-header')) {
  customElements.define('sticky-header', class extends HTMLElement {
    connectedCallback() {
      this.header = document.getElementById('shopify-section-amele-header');
      if(!this.header) return;
      this.lastScroll = window.scrollY;
      this.onScroll = () => {
        const position = window.scrollY;
        const focused = this.header.contains(document.activeElement);
        const open = this.header.querySelector('details[open], .amele-popup-overlay.is-visible');
        this.header.classList.toggle('al-header-hidden', position > this.header.offsetHeight && position > this.lastScroll && !focused && !open);
        this.lastScroll = position;
      };
      window.addEventListener('scroll',this.onScroll,{passive:true});
    }
    disconnectedCallback() { window.removeEventListener('scroll',this.onScroll); }
  });
}
